// src/components/AdPopup.js
import React, { useState, useEffect } from 'react';
import '../css/AdPopup.css';

const AdPopup = () => {
  // Show the ad immediately
  const [showAd, setShowAd] = useState(true);
  // Control whether the user can close the popup
  const [canClose, setCanClose] = useState(false);
  // Track countdown seconds
  const [secondsLeft, setSecondsLeft] = useState(5);

  useEffect(() => {
    let currentTime = 5;
    // Update countdown each second
    const countdown = setInterval(() => {
      currentTime -= 1;
      setSecondsLeft(currentTime);
      // Once we hit 0 seconds, allow close & clear interval
      if (currentTime <= 0) {
        setCanClose(true);
        clearInterval(countdown);
      }
    }, 1000);

    return () => clearInterval(countdown);
  }, []);

  // Close handler
  const closeAd = () => {
    // Only close if canClose is true
    if (canClose) {
      setShowAd(false);
    }
  };

  // If the ad is dismissed, don't render it
  if (!showAd) return null;

  return (
    <div className="ad-popup-overlay">
      <div className="ad-popup">
        {/* Conditionally show the close button once canClose is true */}
        {canClose ? (
          <button className="ad-popup-close" onClick={closeAd}>
            &times;
          </button>
        ) : (
          <div className="ad-popup-countdown">
            Close in {secondsLeft} second{secondsLeft !== 1 ? 's' : ''}
          </div>
        )}

        <h2>Introducing OzAI</h2>
        <p>
          Dive into the next generation of AI with <strong>OzAI</strong>. 
          Streamline your workflow, boost productivity, and explore endless possibilities.
        </p>
        <p>Stay tuned for more updates – the future is here!</p>
      </div>
    </div>
  );
};

export default AdPopup;
